import { environment } from "@env/environment";
import { EnvironmentName } from "@env/environment.interface";

export function getApiUrl(): string {
	if (environment.environmentName === EnvironmentName.LOCAL) {
		return environment.apiBaseUrl;
	}
	return "/api";
}
